import { useAppSelector } from '@/store/StoreHooks'
import Home from '@components/Home/Home'
import { lazy, Suspense, useLayoutEffect, useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import Loader from '../common/Loader/Loader'
import ForgotPassword from '../forgot-password/ForgotPassword'
import Header from '../layout/Header/Header'
import ProfileLayout from '../profile/ProfileLayout'
import OrderHistory from '../profile/order-history/OrderHistory'
import OutstandingDues from '../profile/outstanding-dues/OutstandingDues'
import PaymentMethod from '../profile/payment-method/PaymentMethod'
import Settings from '../profile/settings/Settings'
import SubMembers from '../profile/sub-members/SubMembers'
import ResetPassword from '../reset-password/ResetPassword'
import AuthGuard from './AuthGuard'
import RouteGuard from './RouteGuard'
const Menu = lazy(() => import('@components/Menu/Menu'))
const ContactUs = lazy(() => import('../contact-us/ContactUs'))
const Footer = lazy(() => import('../layout/Footer/Footer'))
const Location = lazy(() => import('../location/Location'))
const AboutUs = lazy(() => import('../about/AboutUs'))
const LocationPopup = lazy(() => import('../popup/Menu/Locations'))
const Catering = lazy(() => import('../Catering/Catering'))
const Signup = lazy(() => import('../signup/Signup'))
const Login = lazy(() => import('../login/Login'))
const VerifyEmail = lazy(() => import('../verify-email/VerifyEmail'))
const MyAccount = lazy(() => import('../profile/my-account/MyAccount'))
const TransactionHistory = lazy(() => import('../profile/transaction-history/TransactionHistory'))
const PaymentSuccess = lazy(() => import('../payment/PaymentSuccess'))
const PaymentCancel = lazy(() => import('../payment/PaymentCancel'))
const NotFound = lazy(() => import('../not-found/NotFound'))

const Wrapper = (props: any) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])
  return props.children
}

function Pages () {
  const loader = useAppSelector(val => val.loader)
  const routes = [
    {
      path: '/',
      component: <Home />,
      requireAuth: false
    },
    {
      path: '/location',
      component: <Location />,
      requireAuth: false
    },
    {
      path: '/contact-us',
      component: <ContactUs />,
      requireAuth: false
    },
    {
      path: '/menu',
      component: <Menu />,
      requireAuth: false
    },
    {
      path: '/about-us',
      component: <AboutUs />,
      requireAuth: false
    },
    {
      path: '/catering',
      component: <Catering />,
      requireAuth: false
    },
    {
      path: '/payment/success',
      component: <PaymentSuccess />,
      requireAuth: false
    },
    {
      path: '/payment/cancel',
      component: <PaymentCancel />,
      requireAuth: false
    },
    {
      path: '/signup',
      component: <Signup />,
      requireAuth: false
    },
    {
      path: '/login',
      component: <Login />,
      requireAuth: false
    },
    {
      path: '/verify-email',
      component: <VerifyEmail />,
      requireAuth: false
    },
    {
      path: '/reset-password',
      component: <ResetPassword />,
      requireAuth: false
    },
    {
      path: '/forgot-password',
      component: <ForgotPassword />,
      requireAuth: false
    },
    {
      path: '/profile/my-account',
      component: <ProfileLayout><MyAccount /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/payment-method',
      component: <ProfileLayout><PaymentMethod /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/family-members',
      component: <ProfileLayout><SubMembers /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/order-history',
      component: <ProfileLayout><OrderHistory /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/outstanding-dues',
      component: <ProfileLayout><OutstandingDues /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/change-password',
      component: <ProfileLayout><Settings /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '/profile/transaction-history',
      component: <ProfileLayout><TransactionHistory /></ProfileLayout>,
      requireAuth: true
    },
    {
      path: '*',
      component: <NotFound />,
      requireAuth: false
    },
  ]
  const [showPopup, setShowPopup] = useState(false);

  const locationCallback = (cb: boolean) => {
    setShowPopup(cb);
  }
  return (
    <>
      <Suspense fallback={<Loader load={loader}></Loader>}>
        <BrowserRouter>
          <Wrapper>
            <Header />

            {!showPopup ? (
              <>
                <Routes>
                  {routes.map((route: any, idx: number) => (
                    <Route
                      key={idx}
                      path={route?.path}
                      element={
                        <AuthGuard requireAuth={route?.requireAuth}>
                          <RouteGuard
                            component={route?.component}
                            callback={locationCallback}
                          />
                        </AuthGuard>
                      }
                    />
                  ))}
                </Routes>
                <Footer />
              </>
            ) : (
              <LocationPopup callback={locationCallback} />
            )}
          </Wrapper>
        </BrowserRouter>
      </Suspense>
    </>
  )
}
export default Pages
